<!--前のページでPOST /book_groupsでデータが作られて入れば描画される-->
<template>
  <div>
    <!-- 生成されたBookGroupのデータが入ったら描画される -->
    <TemplateBookBookingConfirmation v-if="isReadyToDraw" />

    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />
  </div>
</template>

<script>
import { computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import TemplateBookBookingConfirmation from "@/views/Templates/TicketStore/TemplateBookBookingConfirmation";

import storeJS from "@/store";

window.jcCommonTicketReceivePayment = function (url) {
  console.log("jcCommonTicketReceivePayment - Response :: " + url);
  storeJS.commit("ticketing/setPaymentLaunchUrl", url);
};

export default {
  name: "BookBookingConfirmation",
  components: {
    TemplateBookBookingConfirmation: TemplateBookBookingConfirmation,
  },
  setup() {
    const store = useStore();

    store.commit("ticketing/setPaymentLaunchUrl", null);

    const isReadyToDraw = ref(false);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);

    watchEffect(() => {
      if (masterBook.value.id && bookGroup.value.id && book.value.id) {
        isReadyToDraw.value = true;
      }
    });

    return {
      isReadyToDraw,
    };
  },
};
</script>
